<template>
    <b-card no-body>
        <b-card-header class="pb-50">
            <h5>Фильтры</h5>
        </b-card-header>
        <b-card-body>
            <b-row>
                <b-col
                  cols="12"
                  md="3"
                  class="mb-md-0 mb-2"
                >
                    <b-form-group
                        label="Пользователь"
                        class="flex-grow-1"
                        description="Выберите пользователя"
                    >
                        <choose-user-field
                                v-model="formModel['user']"
                                @input="val => formModel['user'] = val"
                        ></choose-user-field>
                    </b-form-group>

                </b-col>
                <b-col
                  cols="12"
                  md="3"
                  class="mb-md-0 mb-2"
                >
                    <b-form-group
                        label="Тип замера"
                        class="flex-grow-1"
                        description="Выберите тип замера"
                    >
                        <choose-measurement-type-field
                                v-model="formModel['type']"
                                @input="val => formModel['type'] = val"
                        ></choose-measurement-type-field>
                    </b-form-group>

                </b-col>
                <b-col
                  cols="12"
                  md="3"
                  class="mb-md-0 mb-2"
                >
                    <b-form-group
                        label="Тип обьекта"
                        class="flex-grow-1"
                        description="Выберите тип обьекта"
                    >
                        <choose-object-type-field
                                v-model="formModel['object_type']"
                                @input="val => formModel['object_type'] = val"
                        ></choose-object-type-field>
                    </b-form-group>

                </b-col>
                 <b-col
                  cols="12"
                  md="3"
                  class="mb-md-0 mb-2"
                >
                     <b-form-group
                        label="Временной промежуток"
                        class="flex-grow-1"
                        description="Выберите временной промежуток"
                    >
                         <b-form-datepicker
                              class="mb-1"
                              placeholder="Начало периода"
                              local="ru"
                              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                              reset-button
                              :reduce="val => val.value"
                              v-model="formModel['start_date']"
                         ></b-form-datepicker>

                         <b-form-datepicker
                             placeholder="Конец периода"
                             local="ru"
                             :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                             reset-button
                             :reduce="val => val.value"
                             v-model="formModel['end_date']"
                         ></b-form-datepicker>
                    </b-form-group>
                </b-col>
          </b-row>

        </b-card-body>
    </b-card>
</template>

<script>
    import {
        BCard,
        BCardHeader,
        BCardBody,
        BRow,
        BCol,
        BFormGroup, BFormDatepicker} from 'bootstrap-vue'
    import { watch, ref } from '@vue/composition-api'

    import ChooseUserField from "@/views/apps/user/components/ChooseUserField";
    import ChooseObjectTypeField from "@/views/apps/infrastructure/object_type/components/ChooseObjectTypeField";
    import ChooseMeasurementTypeField from "../../measurement_type/components/ChooseMeasurementTypeField";


    export default {

        components:{
            BCard,
            BCardHeader,
            BCardBody,
            BRow,
            BCol,
            ChooseMeasurementTypeField,
            ChooseObjectTypeField,
            ChooseUserField,
            BFormGroup,
            BFormDatepicker
        },


        setup(_,{emit}) {


            const formModel = ref({
                    type:'',
                    user: '',
                    object_type: '',
                    start_date: '',
                    end_date: '',
            })


            watch(formModel.value, (value) => emit('filtered', value), { deep: true })

            return {
                formModel,
            }
        },
    }
</script>
